import { render, staticRenderFns } from "./QuoteDrivers.vue?vue&type=template&id=70fe399d&scoped=true"
import script from "./QuoteDrivers.vue?vue&type=script&lang=js"
export * from "./QuoteDrivers.vue?vue&type=script&lang=js"
import style0 from "./QuoteDrivers.vue?vue&type=style&index=0&id=70fe399d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe399d",
  null
  
)

export default component.exports